var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cover_url)?_c('b-card',{staticClass:"mb-3",attrs:{"no-body":""}},[_c('b-card-img',{attrs:{"top":true,"src":_vm.cover_url,"alt":_vm.cover_alt,"srcset":_vm.cover_srcset_array,"sizes":"calc(100vw -30px)"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }